module.exports = __webpack_public_path__ + "img/ico-refresh-grey.30a76c22.svg";